import React from "react";
import { useIsMobile } from "../hooks/useIsMobile";

const ListField = ({
  label,
  children,
  labelWidth = 94,
  errorMessage,
}: {
  label: string;
  children: React.ReactElement;
  labelWidth?: number;
  errorMessage?: string;
}) => {
  const isMobile = useIsMobile(400);

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            fontSize: isMobile ? 14 : 16,
            minWidth: isMobile ? labelWidth * 0.9 : labelWidth,
          }}
        >{`${label}:`}</div>
        {children}
      </div>
      {errorMessage && (
        <div
          style={{
            paddingTop: 3,
            color: "#C52F00",
            fontSize: 10,
            textAlign: "end",
          }}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default ListField;
